import axios from 'axios'
import generalHeader from '../../utils/constants/generalHeader'
import { API_ORIGIN } from '../../utils/constants/url'

// Completes a new SSO user's signup. The pending-signup token carries the
// verified Google/Apple identity; the consent flags + that token are exchanged
// for real access/refresh tokens on the backend, which also persists the user row.
const completeSsoSignup = async ({ pendingSignupToken, marketingConsent, dataSharingConsent }) => {
  const url = `${API_ORIGIN}/v1/auth/sso/complete`

  const response = await axios.post(
    url,
    { pendingSignupToken, marketingConsent, dataSharingConsent },
    {
      headers: generalHeader(),
      withCredentials: true,
    },
  )
  if (response.status !== 200) throw new Error(response.status)
  return response.data
}

export default completeSsoSignup
